export default __webpack_public_path__ + "assets/models/78428dce3569d6955b6a39cdc5d2ee05.glb";